// @flow
import { APICore } from './apiCore';

const api = new APICore();

function ApiGetAllSearch(params: any): any {
    const baseUrl = '/api/admin/inout';
    return api.create(`${baseUrl}`, params);
    // console.log('🚀 ~ ApiGetAllSearch ~ params:', params);
}
function ApiOrderFasilitas(params: any): any {
    const baseUrl = '/api/admin/fasilitas_order';
    return api.create(`${baseUrl}`, params);
}

function ApiOrderMenu(params: any): any {
    const baseUrl = '/api/admin/menu_order';
    return api.create(`${baseUrl}`, params);
}

function ApiOrderRoom(params: any): any {
    const baseUrl = '/api/admin/room_order';
    return api.create(`${baseUrl}`, params);
}
function ApiOrderTerapis(params: any): any {
    const baseUrl = '/api/admin/terapis_order';
    return api.create(`${baseUrl}`, params);
}
function ApiOrderThreatment(params: any): any {
    const baseUrl = '/api/admin/threatment_order';
    return api.create(`${baseUrl}`, params);
}
function ApiEditStatus(params: any, id: any): any {
    const baseUrl = '/api/admin/gelang/' + id;
    // console.log('🚀 ~ ApiEditMenu ~ id:', id);
    return api.update(`${baseUrl}`, params);
}
// function ApiEditStatus(params: any, id: any): any {
//     const baseUrl = '/api/admin/gelang/' + id;
//     console.log('🚀 ~ ApiEditStatus ~ id:', id);
//     return api.update(`${baseUrl}`, params);
// }

export {
    // ApiGetAllKategoriMenu,
    ApiGetAllSearch,
    ApiOrderFasilitas,
    ApiOrderMenu,
    ApiOrderRoom,
    ApiOrderTerapis,
    ApiOrderThreatment,
    ApiEditStatus,
    // ApiGetFetchAllData,
    // ApiPostCategoryRoom,
    // ApiPostKomposisi,
    // ApiEditKategoriRoom,
    // ApiEditKomposisi,
    // ApiDeleteKategoriRoom,
};
